import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ApiCapaService} from '../../_services/apiCapa.service';
import {AccountModel} from '../../_models/CapaModels/Account.model';
import {InstallModel} from '../../_models/CapaModels/install.model';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.css']
})
export class CreateAccountComponent implements OnInit {

  errorLicenseNumber: boolean;
  errorAccountCreation: boolean;
  successAccountCreation: boolean;
  errorPassword: boolean;

  LicenseNumberForm: FormGroup;
  DetailsForm: FormGroup;

  Install: InstallModel;

  public isLicenseNumberValid: boolean = false;

  constructor(private router: Router,
              private formBuilder: FormBuilder,
              private apiClient: ApiCapaService) { }

  ngOnInit() {
    this.LicenseNumberForm = this.formBuilder.group({
      licenseNumber: ['', Validators.required]
    });

    // Mot de passe contenant au moin 8 caractères dont au moins un chiffre
    const pwdRegex: RegExp = new RegExp('^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,}$');

    // Adresse email type exemple@cotral.com
    const emailRegex: RegExp = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$');

    this.DetailsForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      language: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(emailRegex)]],
      password: ['', [Validators.required, Validators.pattern(pwdRegex)]],
      phone: [''],
    });
  }

  onSubmitLicenseNumber() {
    this.apiClient.get('Installs/' + this.LicenseNumberForm.value.licenseNumber).subscribe(response => {
      this.Install = response != null ? response : null;
      if (this.Install != null && this.Install.idAccount == null) {
        this.isLicenseNumberValid = true;
        this.errorLicenseNumber = false;
       } else {
        this.errorLicenseNumber = true;
      }
    });
  }

  onSubmitDetails() {
    if (this.DetailsForm.value.password.length < 8) {
      this.errorPassword = true;
      return;
    }

    const lang = this.DetailsForm.value.language;

    const account: AccountModel = {
      company: '',
      creeLe: Date.now().toString(),
      email: this.DetailsForm.value.email,
      firstName: this.DetailsForm.value.firstname,
      idAccount: 'WBSERVER_' + Date.now(),
      language: lang === 'Français' ? 5 : (lang === 'Anglais' ? 3 : 1), // Français = 5, Anglais = 3, Allemand = 1
      lastConnexionDate: new Date(),
      lastName: this.DetailsForm.value.lastname,
      modifieLe: new Date(),
      password: this.DetailsForm.value.password,
      phone: this.DetailsForm.value.phone
    };

    this.apiClient.post('Accounts/filtered-list', {'Email': this.DetailsForm.value.email}).subscribe(response => {
      if (response['infos'][0]['count'] === 0) {
        this.errorAccountCreation = false;
        this.apiClient.post('Accounts/', account).subscribe(result => {
          this.errorAccountCreation = false;
          this.successAccountCreation = true;
          this.Install.idAccount = account.idAccount;
          this.apiClient.put('Installs/', this.Install).subscribe(data => {});
        });
      } else {
        this.errorAccountCreation = true;
      }
    });
  }
}
